/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_requestCard_requestBulkSaveMessageForRequestUser } from '../models/api_requestCard_requestBulkSaveMessageForRequestUser';
import type { api_requestCard_requestBulkSavePatientFileForRequestUser } from '../models/api_requestCard_requestBulkSavePatientFileForRequestUser';
import type { api_requestCard_requestBulkUpdateRequestStatus } from '../models/api_requestCard_requestBulkUpdateRequestStatus';
import type { api_requestCard_requestCreateRequestCards } from '../models/api_requestCard_requestCreateRequestCards';
import type { api_requestCard_requestDeleteRequestCard } from '../models/api_requestCard_requestDeleteRequestCard';
import type { api_requestCard_requestGetLastSentRequestCard } from '../models/api_requestCard_requestGetLastSentRequestCard';
import type { api_requestCard_requestGetRequestCardForPortalStaff } from '../models/api_requestCard_requestGetRequestCardForPortalStaff';
import type { api_requestCard_requestGetRequestCardForRequestUser } from '../models/api_requestCard_requestGetRequestCardForRequestUser';
import type { api_requestCard_requestListFolder } from '../models/api_requestCard_requestListFolder';
import type { api_requestCard_requestListMessageForPortalStaff } from '../models/api_requestCard_requestListMessageForPortalStaff';
import type { api_requestCard_requestListMessageForRequestUser } from '../models/api_requestCard_requestListMessageForRequestUser';
import type { api_requestCard_requestListRequestCardForPortalStaff } from '../models/api_requestCard_requestListRequestCardForPortalStaff';
import type { api_requestCard_requestListRequestCardForRequestUser } from '../models/api_requestCard_requestListRequestCardForRequestUser';
import type { api_requestCard_requestMoveFolder } from '../models/api_requestCard_requestMoveFolder';
import type { api_requestCard_requestRenewPatientAutoUpdate } from '../models/api_requestCard_requestRenewPatientAutoUpdate';
import type { api_requestCard_requestSaveMessageForPortalStaff } from '../models/api_requestCard_requestSaveMessageForPortalStaff';
import type { api_requestCard_requestSaveMessageForRequestUser } from '../models/api_requestCard_requestSaveMessageForRequestUser';
import type { api_requestCard_requestSaveRequestCard } from '../models/api_requestCard_requestSaveRequestCard';
import type { api_requestCard_requestSearchRequestCardForRequestUser } from '../models/api_requestCard_requestSearchRequestCardForRequestUser';
import type { api_requestCard_requestUpdateAcceptStatus } from '../models/api_requestCard_requestUpdateAcceptStatus';
import type { api_requestCard_requestUpdateIsCompletedForPortalStaff } from '../models/api_requestCard_requestUpdateIsCompletedForPortalStaff';
import type { api_requestCard_requestUpdateIsCompletedForRequestUser } from '../models/api_requestCard_requestUpdateIsCompletedForRequestUser';
import type { api_requestCard_requestUpdateIsRead } from '../models/api_requestCard_requestUpdateIsRead';
import type { api_requestCard_requestUpdateIsSent } from '../models/api_requestCard_requestUpdateIsSent';
import type { api_requestCard_requestUpdatePortalStaff } from '../models/api_requestCard_requestUpdatePortalStaff';
import type { api_requestCard_requestUpdateRequestStatus } from '../models/api_requestCard_requestUpdateRequestStatus';
import type { api_requestCard_responseBulkSaveMessageForRequestUser } from '../models/api_requestCard_responseBulkSaveMessageForRequestUser';
import type { api_requestCard_responseBulkSavePatientFileForRequestUser } from '../models/api_requestCard_responseBulkSavePatientFileForRequestUser';
import type { api_requestCard_responseBulkUpdateRequestStatus } from '../models/api_requestCard_responseBulkUpdateRequestStatus';
import type { api_requestCard_responseCreateRequestCards } from '../models/api_requestCard_responseCreateRequestCards';
import type { api_requestCard_responseDeleteRequestCard } from '../models/api_requestCard_responseDeleteRequestCard';
import type { api_requestCard_responseGetLastSentRequestCard } from '../models/api_requestCard_responseGetLastSentRequestCard';
import type { api_requestCard_responseGetRequestCardForPortalStaff } from '../models/api_requestCard_responseGetRequestCardForPortalStaff';
import type { api_requestCard_responseGetRequestCardForRequestUser } from '../models/api_requestCard_responseGetRequestCardForRequestUser';
import type { api_requestCard_responseListFolder } from '../models/api_requestCard_responseListFolder';
import type { api_requestCard_responseListMessageForPortalStaff } from '../models/api_requestCard_responseListMessageForPortalStaff';
import type { api_requestCard_responseListMessageForRequestUser } from '../models/api_requestCard_responseListMessageForRequestUser';
import type { api_requestCard_responseListRequestCardForPortalStaff } from '../models/api_requestCard_responseListRequestCardForPortalStaff';
import type { api_requestCard_responseListRequestCardForRequestUser } from '../models/api_requestCard_responseListRequestCardForRequestUser';
import type { api_requestCard_responseMoveFolder } from '../models/api_requestCard_responseMoveFolder';
import type { api_requestCard_responseRenewPatientAutoUpdate } from '../models/api_requestCard_responseRenewPatientAutoUpdate';
import type { api_requestCard_responseSaveMessageForPortalStaff } from '../models/api_requestCard_responseSaveMessageForPortalStaff';
import type { api_requestCard_responseSaveMessageForRequestUser } from '../models/api_requestCard_responseSaveMessageForRequestUser';
import type { api_requestCard_responseSaveRequestCard } from '../models/api_requestCard_responseSaveRequestCard';
import type { api_requestCard_responseSearchRequestCardForRequestUser } from '../models/api_requestCard_responseSearchRequestCardForRequestUser';
import type { api_requestCard_responseUpdateAcceptStatus } from '../models/api_requestCard_responseUpdateAcceptStatus';
import type { api_requestCard_responseUpdateIsCompletedForPortalStaff } from '../models/api_requestCard_responseUpdateIsCompletedForPortalStaff';
import type { api_requestCard_responseUpdateIsCompletedForRequestUser } from '../models/api_requestCard_responseUpdateIsCompletedForRequestUser';
import type { api_requestCard_responseUpdateIsRead } from '../models/api_requestCard_responseUpdateIsRead';
import type { api_requestCard_responseUpdateIsSent } from '../models/api_requestCard_responseUpdateIsSent';
import type { api_requestCard_responseUpdatePortalStaff } from '../models/api_requestCard_responseUpdatePortalStaff';
import type { api_requestCard_responseUpdateRequestStatus } from '../models/api_requestCard_responseUpdateRequestStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class RequestCardService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Bulk Save RequestCardMessage
     * 依頼カードメッセージを一括保存する（利用ユーザー用）
     * @returns api_requestCard_responseBulkSaveMessageForRequestUser responseBulkSaveMessageForRequestUser
     * @throws ApiError
     */
    public postRequestCardBulkSaveMessageForRequestUser({
        body,
    }: {
        /**
         * requestBulkSaveMessageForRequestUser
         */
        body: api_requestCard_requestBulkSaveMessageForRequestUser,
    }): CancelablePromise<api_requestCard_responseBulkSaveMessageForRequestUser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/bulk_save_message_for_request_user',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Bulk Save RequestCardPatientFile
     * 利用者関連ファイルを複数の紹介カードに紐づけます
     * @returns api_requestCard_responseBulkSavePatientFileForRequestUser responseBulkSavePatientFileForRequestUser
     * @throws ApiError
     */
    public postRequestCardBulkSavePatientFileForRequestUser({
        body,
    }: {
        /**
         * requestBulkSavePatientFileForRequestUser
         */
        body: api_requestCard_requestBulkSavePatientFileForRequestUser,
    }): CancelablePromise<api_requestCard_responseBulkSavePatientFileForRequestUser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/bulk_save_patient_file_for_request_user',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * BulkUpdate RequestStatus
     * 依頼カードの紹介ステータスを一括で更新する
     * @returns api_requestCard_responseBulkUpdateRequestStatus responseBulkUpdateRequestStatus
     * @throws ApiError
     */
    public postRequestCardBulkUpdateRequestStatus({
        body,
    }: {
        /**
         * requestBulkUpdateRequestStatus
         */
        body: api_requestCard_requestBulkUpdateRequestStatus,
    }): CancelablePromise<api_requestCard_responseBulkUpdateRequestStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/bulk_update_request_status',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create Request Cards
     * 依頼カードを一括で登録し、送信する
     * @returns api_requestCard_responseCreateRequestCards responseCreateRequestCards
     * @throws ApiError
     */
    public postRequestCardCreateMulti({
        body,
    }: {
        /**
         * requestCreateRequestCards
         */
        body: api_requestCard_requestCreateRequestCards,
    }): CancelablePromise<api_requestCard_responseCreateRequestCards> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/create_multi',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Soft delete RequestCard draft
     * 紹介カードの下書きを削除する。
     * @returns api_requestCard_responseDeleteRequestCard responseDeleteRequestCard
     * @throws ApiError
     */
    public postRequestCardDelete({
        body,
    }: {
        /**
         * requestDeleteRequestCard
         */
        body: api_requestCard_requestDeleteRequestCard,
    }): CancelablePromise<api_requestCard_responseDeleteRequestCard> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/delete',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get RequestCard
     * 依頼カードを1件取得する（掲載スタッフ用）。未送信の依頼カードは取得不可。閲覧期限を過ぎた患者の個人情報はマスキングする。
     * @returns api_requestCard_responseGetRequestCardForPortalStaff responseGetRequestCardForPortalStaff
     * @throws ApiError
     */
    public postRequestCardGetForPortalStaff({
        body,
    }: {
        /**
         * requestGetRequestCardForPortalStaff
         */
        body: api_requestCard_requestGetRequestCardForPortalStaff,
    }): CancelablePromise<api_requestCard_responseGetRequestCardForPortalStaff> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/get_for_portal_staff',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get RequestCard
     * 依頼カードを1件取得する（依頼ユーザー用）
     * @returns api_requestCard_responseGetRequestCardForRequestUser responseGetRequestCardForRequestUser
     * @throws ApiError
     */
    public postRequestCardGetForRequestUser({
        body,
    }: {
        /**
         * requestGetRequestCardForRequestUser
         */
        body: api_requestCard_requestGetRequestCardForRequestUser,
    }): CancelablePromise<api_requestCard_responseGetRequestCardForRequestUser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/get_for_request_user',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Last Sent RequestCard
     * 組織が最後に送信した依頼カードを取得する。依頼カード新規作成時に前回送信した内容を参照する際の使用を想定し、それに必要な項目のみを取得する。
     * @returns api_requestCard_responseGetLastSentRequestCard responseGetLastSentRequestCard
     * @throws ApiError
     */
    public postRequestCardGetLastSent({
        body,
    }: {
        /**
         * requestGetLastSentRequestCard
         */
        body: api_requestCard_requestGetLastSentRequestCard,
    }): CancelablePromise<api_requestCard_responseGetLastSentRequestCard> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/get_last_sent',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List RequestCardFolder
     * 指定された患者に対する紹介依頼カードのフォルダ一覧を取得する
     * @returns api_requestCard_responseListFolder responseListFolder
     * @throws ApiError
     */
    public postRequestCardListFolder({
        body,
    }: {
        /**
         * requestListFolder
         */
        body: api_requestCard_requestListFolder,
    }): CancelablePromise<api_requestCard_responseListFolder> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/list_folder',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List RequestCard
     * 依頼カードを複数件取得する（掲載スタッフ用）
     * @returns api_requestCard_responseListRequestCardForPortalStaff responseListRequestCardForPortalStaff
     * @throws ApiError
     */
    public postRequestCardListForPortalStaff({
        body,
    }: {
        /**
         * requestListRequestCardForPortalStaff
         */
        body: api_requestCard_requestListRequestCardForPortalStaff,
    }): CancelablePromise<api_requestCard_responseListRequestCardForPortalStaff> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/list_for_portal_staff',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List RequestCard
     * 依頼カードを複数件取得する（依頼ユーザー用）
     * @returns api_requestCard_responseListRequestCardForRequestUser responseListRequestCardForRequestUser
     * @throws ApiError
     */
    public postRequestCardListForRequestUser({
        body,
    }: {
        /**
         * requestListRequestCardForRequestUser
         */
        body: api_requestCard_requestListRequestCardForRequestUser,
    }): CancelablePromise<api_requestCard_responseListRequestCardForRequestUser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/list_for_request_user',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List RequestCardMessage
     * 依頼カードメッセージの一覧を取得する（掲載スタッフ用）。取得の際、依頼元組織から届いたメッセージを既読に更新する。
     * @returns api_requestCard_responseListMessageForPortalStaff responseListMessageForPortalStaff
     * @throws ApiError
     */
    public postRequestCardListMessageForPortalStaff({
        body,
    }: {
        /**
         * requestListMessageForPortalStaff
         */
        body: api_requestCard_requestListMessageForPortalStaff,
    }): CancelablePromise<api_requestCard_responseListMessageForPortalStaff> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/list_message_for_portal_staff',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List RequestCardMessage
     * 依頼カードメッセージの一覧を取得する（依頼ユーザー用）。取得の際、依頼先オフィスから届いたメッセージを既読に更新する。
     * @returns api_requestCard_responseListMessageForRequestUser responseListMessageForRequestUser
     * @throws ApiError
     */
    public postRequestCardListMessageForRequestUser({
        body,
    }: {
        /**
         * requestListMessageForRequestUser
         */
        body: api_requestCard_requestListMessageForRequestUser,
    }): CancelablePromise<api_requestCard_responseListMessageForRequestUser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/list_message_for_request_user',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Move RequestCardFolder
     * 紹介依頼カードを、同一利用者の別のフォルダに移動する
     * @returns api_requestCard_responseMoveFolder responseMoveFolder
     * @throws ApiError
     */
    public postRequestCardMoveFolder({
        body,
    }: {
        /**
         * requestMoveFolder
         */
        body: api_requestCard_requestMoveFolder,
    }): CancelablePromise<api_requestCard_responseMoveFolder> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/move_folder',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Renew Patient Auto Update
     * 紹介カードの利用者情報自動更新を再開する。
     * @returns api_requestCard_responseRenewPatientAutoUpdate responseRenewPatientAutoUpdate
     * @throws ApiError
     */
    public postRequestCardRenewPatientAutoUpdate({
        body,
    }: {
        /**
         * requestRenewPatientAutoUpdate
         */
        body: api_requestCard_requestRenewPatientAutoUpdate,
    }): CancelablePromise<api_requestCard_responseRenewPatientAutoUpdate> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/renew_patient_auto_update',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Save RequestCard
     * 依頼カードを保存する（id=nullでInsert、id指定でUpdate）
     * @returns api_requestCard_responseSaveRequestCard responseSaveRequestCard
     * @throws ApiError
     */
    public postRequestCardSave({
        body,
    }: {
        /**
         * requestSaveRequestCard
         */
        body: api_requestCard_requestSaveRequestCard,
    }): CancelablePromise<api_requestCard_responseSaveRequestCard> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/save',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Save RequestCardMessage
     * 依頼カードメッセージを保存する（掲載スタッフ用）。依頼カードが未読の場合は既読に更新する。依頼カードの担当者が未設定の場合、メッセージ投稿者を担当者に自動設定する。
     * @returns api_requestCard_responseSaveMessageForPortalStaff responseSaveMessageForPortalStaff
     * @throws ApiError
     */
    public postRequestCardSaveMessageForPortalStaff({
        body,
    }: {
        /**
         * requestSaveMessageForPortalStaff
         */
        body: api_requestCard_requestSaveMessageForPortalStaff,
    }): CancelablePromise<api_requestCard_responseSaveMessageForPortalStaff> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/save_message_for_portal_staff',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Save RequestCardMessage
     * 依頼カードメッセージを保存する（利用ユーザー用）
     * @returns api_requestCard_responseSaveMessageForRequestUser responseSaveMessageForRequestUser
     * @throws ApiError
     */
    public postRequestCardSaveMessageForRequestUser({
        body,
    }: {
        /**
         * requestSaveMessageForRequestUser
         */
        body: api_requestCard_requestSaveMessageForRequestUser,
    }): CancelablePromise<api_requestCard_responseSaveMessageForRequestUser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/save_message_for_request_user',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search RequestCard
     * 依頼カードを検索する（依頼ユーザー用）
     * @returns api_requestCard_responseSearchRequestCardForRequestUser responseSearchRequestCardForRequestUser
     * @throws ApiError
     */
    public postRequestCardSearchForRequestUser({
        body,
    }: {
        /**
         * requestSearchRequestCardForRequestUser
         */
        body: api_requestCard_requestSearchRequestCardForRequestUser,
    }): CancelablePromise<api_requestCard_responseSearchRequestCardForRequestUser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/search_for_request_user',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update AcceptStatus
     * 依頼カードの受け入れステータスを更新する
     * @returns api_requestCard_responseUpdateAcceptStatus responseUpdateAcceptStatus
     * @throws ApiError
     */
    public postRequestCardUpdateAcceptStatus({
        body,
    }: {
        /**
         * requestUpdateAcceptStatus
         */
        body: api_requestCard_requestUpdateAcceptStatus,
    }): CancelablePromise<api_requestCard_responseUpdateAcceptStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/update_accept_status',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update IsCompleted
     * ポータルオフィス側の対応完了フラグを対応完了または未対応に更新する。対応完了に更新する際、その依頼カードが未読の場合は既読に更新する。依頼カードの担当者が未設定の場合、実行者を担当者に自動設定する。
     * @returns api_requestCard_responseUpdateIsCompletedForPortalStaff responseUpdateIsCompletedForPortalStaff
     * @throws ApiError
     */
    public postRequestCardUpdateIsCompletedForPortalStaff({
        body,
    }: {
        /**
         * requestUpdateIsCompletedForPortalStaff
         */
        body: api_requestCard_requestUpdateIsCompletedForPortalStaff,
    }): CancelablePromise<api_requestCard_responseUpdateIsCompletedForPortalStaff> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/update_is_completed_for_portal_staff',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update IsCompleted
     * 依頼組織側の対応完了フラグを対応完了または未対応に更新する。
     * @returns api_requestCard_responseUpdateIsCompletedForRequestUser responseUpdateIsCompletedForRequestUser
     * @throws ApiError
     */
    public postRequestCardUpdateIsCompletedForRequestUser({
        body,
    }: {
        /**
         * requestUpdateIsCompletedForRequestUser
         */
        body: api_requestCard_requestUpdateIsCompletedForRequestUser,
    }): CancelablePromise<api_requestCard_responseUpdateIsCompletedForRequestUser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/update_is_completed_for_request_user',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update IsRead
     * 依頼カードを既読に更新する。依頼カードの担当者が未設定の場合、実行者を担当者に自動設定する。
     * @returns api_requestCard_responseUpdateIsRead responseUpdateIsRead
     * @throws ApiError
     */
    public postRequestCardUpdateIsRead({
        body,
    }: {
        /**
         * requestUpdateIsRead
         */
        body: api_requestCard_requestUpdateIsRead,
    }): CancelablePromise<api_requestCard_responseUpdateIsRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/update_is_read',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update IsSent
     * 依頼カードを送信済みまたは下書きに更新する。
     * @returns api_requestCard_responseUpdateIsSent responseUpdateIsSent
     * @throws ApiError
     */
    public postRequestCardUpdateIsSent({
        body,
    }: {
        /**
         * requestUpdateIsSent
         */
        body: api_requestCard_requestUpdateIsSent,
    }): CancelablePromise<api_requestCard_responseUpdateIsSent> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/update_is_sent',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update PortalStaff
     * 依頼カードの対応担当ポータルスタッフを更新する。依頼カードが未読の場合は既読に更新する。
     * @returns api_requestCard_responseUpdatePortalStaff responseUpdatePortalStaff
     * @throws ApiError
     */
    public postRequestCardUpdatePortalStaff({
        body,
    }: {
        /**
         * requestUpdatePortalStaff
         */
        body: api_requestCard_requestUpdatePortalStaff,
    }): CancelablePromise<api_requestCard_responseUpdatePortalStaff> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/update_portal_staff',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update RequestStatus
     * 依頼カードの紹介ステータスを更新する
     * @returns api_requestCard_responseUpdateRequestStatus responseUpdateRequestStatus
     * @throws ApiError
     */
    public postRequestCardUpdateRequestStatus({
        body,
    }: {
        /**
         * requestUpdateRequestStatus
         */
        body: api_requestCard_requestUpdateRequestStatus,
    }): CancelablePromise<api_requestCard_responseUpdateRequestStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_card/update_request_status',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
